module.exports = __webpack_public_path__ + "img/2.09bd90b2.png";